import React from 'react'
import { useForm } from "react-hook-form";
import Layout from '../../components/Layout'
import { navigate } from 'gatsby'
import { ErrorMessage } from '@hookform/error-message';

export default function Prijava() {
    const { register, handleSubmit, watch, errors } = useForm({

    });
    const onSubmit = data => {
        fetch('https://api.sheetmonkey.io/form/oZ98F2USaghXa6QCXFy2Kz', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        }).then((result) => {
            return navigate('/prijava/uspesno')
          });
    }

    const watchStClanov = watch('stClanov');
    const watchKategorija = watch('kategorija');
    const watchNasitek = watch('nasitek');

    function clanNumbers() {
        return [...Array(parseInt(watchStClanov || 0)).keys()];
    }

    function letnica() {
        if (watchKategorija == "PP+") {
            return 2010
        }
        if (watchKategorija == "GG+") {
            return 2010
        }
        return 2010
    }


    return (
        <Layout>
            <main className="container px-6 font-medium text-primary">
                <h1 className="text-5xl mt-16 mb-8 lg:text-6xl lg:my-16 xl:text-7xl xl:my-20 mb-5">Prijava na ZOT 2021</h1>
                <section className=" lg:text-xl text-lg text-container">
                    <p className="pb-6">Prosimo vas, da prijavnico izpolnite čimbolj točno in v skladu z razpisom.</p>
                </section>

                <form onSubmit={handleSubmit(onSubmit)} className="text-container">
                    <h2 className="pb-3 lg:pb-6 text-3xl lg:text-4xl xl:text-5xl">Osnovni podatki</h2>
                    <div className="mb-5">
                        <label className="text-2xl text-primary font-semibold" htmlFor="teamName">Ime ekipe</label>
                        <input
                            className="p-2 text-xl text-primary border-2 border-primary w-full mt-1"
                            name="teamName"
                            placeholder="Ime ekipe"
                            ref={register({
                                required: { value: true, message: "Polje je obvezno." },
                                maxLength: { value: 32, message: "Ime ekipe je predolgo. Ime ekipe je lahko dolgo le 32 znakov." },
                                minLength: { value: 4, message: "Ime ekipe je prekratko." }
                            })} />
                        {errors.teamName && <p className="text-red-500">{errors.teamName.message}</p>}
                    </div>

                    <div className="mb-5">
                        <label className="text-2xl text-primary font-semibold" htmlFor="rod">Rod/društvo</label>
                        <input
                            className="p-2 text-xl text-primary border-2 border-primary w-full mt-1"
                            name="rod"
                            placeholder="Rod"
                            ref={register({
                                required: { value: true, message: "Polje je obvezno." },
                            })} />
                        {errors.rod && <p className="text-red-500">{errors.rod.message}</p>}
                    </div>

                    <div className="mb-5">
                        <label className="text-2xl text-primary font-semibold" htmlFor="email">E-mail vodje ekipe</label>
                        <input
                            className="p-2 text-xl text-primary border-2 border-primary w-full mt-1"
                            name="email"
                            type="email"
                            placeholder="E-mail"
                            ref={register({
                                required: { value: true, message: "Polje je obvezno." },
                            })} />
                        {errors.rod && <p className="text-red-500">{errors.email.message}</p>}
                    </div>

                    <div className="mb-5">
                        <label className="text-2xl text-primary font-semibold" htmlFor="telefon">Telefon vodje ekipe</label>
                        <input
                            className="p-2 text-xl text-primary border-2 border-primary w-full mt-1"
                            name="telefon"
                            placeholder="Telefon"
                            ref={register({
                                required: { value: true, message: "Polje je obvezno." },
                            })} />
                        {errors.rod && <p className="text-red-500">{errors.telefon.message}</p>}
                    </div>

                    <div className="flex">
                        <div className="mb-5 w-1/2 pr-2">
                            <label className="text-2xl text-primary font-semibold" htmlFor="kategorija">Kategorija</label>
                            <select
                                className="p-2 text-xl text-primary border-2 border-primary w-full mt-1"
                                name="kategorija"
                                ref={register({
                                    required: { value: true, message: "Polje je obvezno." },
                                })}
                            >
                                <option value=""></option>
                                <option value="gg">GG</option>
                                <option value="pp+">PP+</option>
                            </select>

                            {errors.kategorija && <p className="text-red-500">{errors.kategorija.message}</p>}
                        </div>

                        <div className="mb-5 w-1/2 pr-2">
                            <label className="text-2xl text-primary font-semibold" htmlFor="stClanov">Število članov</label>
                            <select
                                className="p-2 text-xl text-primary border-2 border-primary w-full mt-1"
                                name="stClanov"
                                ref={register({
                                    required: { value: true, message: "Polje je obvezno." },
                                })}
                            >
                                {['', 3, 4, 5].map(i =>
                                    <option key={i} value={i}>{i}</option>
                                )}
                            </select>

                            {errors.stClanov && <p className="text-red-500">{errors.stClanov.message}</p>}
                        </div>
                    </div>
                    <hr className="mb-5" />


                    {clanNumbers().map(i => {
                        const catId = `name-${i}`;
                        const leto = `leto-${i}`;
                        return (
                            <div key={i} className="mb-5">

                                <h2 className="pb-3 lg:pb-6 text-3xl lg:text-4xl xl:text-5xl"> Član {i + 1}</h2>
                                <div className="flex">
                                    <div className="w-2/3 pr-2">
                                        <label className="text-xl text-primary font-semibold" htmlFor={catId}>Ime in priimek</label>
                                        <input
                                            className="p-2 text-lg text-primary border-2 border-primary w-full mt-1"
                                            name={catId}
                                            placeholder={`Ime in priimek`}
                                            ref={register({
                                                required: { value: true, message: "Polje je obvezno." },
                                            })} />
                                        <ErrorMessage
                                            errors={errors}
                                            name={catId}
                                            render={({ message }) => <p className="text-red-500">{message}</p>}
                                        />
                                    </div>
                                    <div className="w-1/3 pl-2">
                                        <label className="text-xl text-primary font-semibold" htmlFor={leto}>Leto rojstva</label>
                                        <input
                                            className="p-2 text-lg text-primary border-2 border-primary w-full mt-1"
                                            name={leto}
                                            type="number"
                                            placeholder={`LLLL`}
                                            ref={register({
                                                required: { value: true, message: "Polje je obvezno." },
                                                max: { value: letnica(), message: "Tekmovalec je še premlad." },
                                                min: { value: 1900, message: "Vpišite veljavno leto rojstva" }
                                            })} />
                                        <ErrorMessage
                                            errors={errors}
                                            name={leto}
                                            render={({ message }) => <p className="text-red-500">{message}</p>}
                                        />
                                    </div></div>
                                <hr className="my-5" />
                            </div>

                        )
                    })}

                    <h2 className="pb-3 lg:pb-6 text-3xl lg:text-4xl xl:text-5xl">Drugo</h2>
                    <div className="mb-5">
                        <label className="text-2xl text-primary font-semibold" htmlFor="nasitek">Število našitkov (2 €/našitek)</label>
                        <div className="flex items-center justify-between">
                            <input
                                className="p-2 w-1/2 text-xl text-primary border-2 border-primary mt-1"
                                name="nasitek"
                                type="number"
                                ref={register({
                                    max: { value: 5, message: "Največ 5 našitkov na ekipo." },
                                    min: { value: 0, message: "Število ne more biti negativno." }
                                })} />
                            <div className="text-2xl">
                                Skupaj: {watchNasitek && watchNasitek * 2} €
                            </div>
                        </div>
                        {errors.nasitek && <p className="text-red-500">{errors.nasitek.message}</p>}
                    </div>

                    <div className="mb-5">
                        <label className="text-2xl text-primary font-semibold" htmlFor="drugo">Drugo</label>
                        <textarea
                            className="p-2 text-xl text-primary border-2 border-primary w-full mt-1"
                            name="drugo"
                            ref={register} />
                        {errors.drugo && <p className="text-red-500">{errors.drugo.message}</p>}
                    </div>

                    <button type="submit" className="py-3 block w-full text-center text-3xl text-white bg-primary">Prijavi</button>
                </form>
            </main>
        </Layout>
    );
}